import { useState } from "react";
import { url } from '../utils/config';
import axios from 'axios';
import { toast } from "react-toastify";
import { Card } from "flowbite-react";
import { btnCancel, btnOne, btnTwo, inputStyleTwo, label, title } from "../utils/style";
import compareDate from "../helper_functions/compareDate";

function BookingForm(props) {
    const [ formData, setFormData ] = useState({special_equipment_id: props.id});

    async function requestEquipmentBooking() {
        var error = false
        if(compareDate(formData.date) === 'future' || compareDate(formData.date) === 'present') {
        } else {
            toast.error('Past Date Cannot be selected!', { autoClose: 3000 })
            error = true
        }

        if ( formData.checkinTime === formData.checkoutTime ) {
            toast.error('Checkin Time & Checkout Time cannot be same!', { autoClose: 3000 });
            error = true
        }

        if(!error) {
            {
                try {
                    const reqUrl = url + '/booking_request';
                    const token = window.localStorage.getItem('token');
                    const headers = { authorization: `bearer ${token}` };
                    const {data} = await axios.post(reqUrl, formData, { headers });
                    props.setShowModal(false);
                    toast.success(data.message, { autoClose: 3000 })
                } catch (error) {
                    toast.error(error.response.data.message, { autoClose: 3000 })
                }
            }
        }
    }

    async function requestEquipmentExtension() {
        try {
            const reqData = {
                id: props.equipmentData.id,
                checkoutTime: formData.checkoutTime
            }
            const reqUrl = url + '/extend_booking';
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const data = await axios.post(reqUrl, reqData, { headers });
            console.log(data.data);
            props.setShowModal(false)
        } catch (error) {
            console.log(error)
        }
    }

    function updateFormData(e) {
        const { name, value } = e.target;
        const data = {...formData};
        data[name] = value;
        setFormData(data)
    }


    return(        
        <div className="flex justify-center items-center bg-white p-4 fixed top-0 left-0 h-screen w-screen">
            <div className="px-4 py-8 bg-white w-full rounded-lg shadow-xl">
                <div className="text-center"><span className={title}>Request New Equipment</span></div>
                <div>
                    <div className={label}>Equipment Name</div>
                    <input type='text' disabled name='name' value={props.name} className={inputStyleTwo} />
                    <div className={label}>Date</div>
                    {
                        !props.extension ? 
                        <input type='date' name='date' placeholder="date" className={inputStyleTwo} onChange={e => updateFormData(e)} />
                        :
                        <div>{props.equipmentData.date}</div>
                    }
                    <div className={label}>Check-In Time</div>
                    {
                        !props.extension ? 
                        <input type='time' name='checkinTime' placeholder="checkinTime" className={inputStyleTwo} onChange={e => updateFormData(e)}/>
                        :
                        <div>{props.equipmentData.checkinTime}</div>
                    }
                    <div className={label}>Check-Out Time</div>
                    {
                        !props.extension ? 
                        <input type='time' name='checkoutTime' placeholder="checkoutTime" className={inputStyleTwo} onChange={e => updateFormData(e)}/>
                        :
                        <div>{props.equipmentData.checkoutTime}</div>
                    }
                    {
                        props.extension ? 
                        <div>
                            <div className={label}>New Check-Out Time</div>
                            <input type='time' name='checkoutTime' className={inputStyleTwo} onChange={e => updateFormData(e)}/>
                        </div> : null
                    }
                </div>
                <div className="flex justify-between items-center gap-4 py-4">
                    <button className={btnCancel} onClick={() => props.setShowModal(false)}>Cancel</button>
                    <button onClick={() => !props.extension ? requestEquipmentBooking() : requestEquipmentExtension()} className={btnOne}>Request</button>
                </div>
            </div>
        </div>
    )
}

export default BookingForm;